import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-lg text-center">
      <h2 className="text-2xl font-semibold text-gray-800">Seite nicht gefunden</h2>
      <p className="mt-2 text-sm text-gray-500">
        Die angeforderte Route existiert nicht.
      </p>
      <Link
        to="/research-jobs"
        className="mt-6 inline-flex rounded-lg bg-violet-600 px-4 py-2 text-sm font-medium text-white hover:bg-violet-700"
      >
        Zur Job-Liste
      </Link>
    </div>
  );
}
